import React from "react";
export default() =>(
    <div>
        <footer className="page-footer font-small blue pt-4 footer">

        </footer>
    </div>
)